module.exports = __webpack_public_path__ + "static/media/no-tasks.6ff9d0f8.png";